import { createFileRoute } from "@tanstack/react-router";

import { PraxaWorkflowCatalog } from "../components/praxa/PraxaWorkflowSurface";

export const Route = createFileRoute("/w/$workspaceId/workflows/")({
  component: PraxaWorkflowsRoute,
});

function PraxaWorkflowsRoute() {
  const { workspaceId } = Route.useParams();
  return <PraxaWorkflowCatalog workspaceId={workspaceId} />;
}
